<button
  class="az-button"
  [class.az-button--icon-right]="iconPosition === 'right'"
  [class.az-button--default]="variant === 'default'"
  [class.az-button--primary]="variant === 'primary'"
  [disabled]="disabled"
>
  @if (showIcon && icon && iconPosition === 'left') {
    <span class="material-symbols-outlined az-button__icon">{{ icon }}</span>
  }
  @if (label) {
    <span class="az-button__label">{{ label }}</span>
  }
  @if (showIcon && icon && iconPosition === 'right') {
    <span class="material-symbols-outlined az-button__icon">{{ icon }}</span>
  }
</button>
